import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SettingsService} from "../../services/settings-service.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";

export class generalTasksConfigurationViewCtrl implements IController {

  type: any;
  generalTasks: any;
  preferences: any;

  public includeRouteStartEndInDispatchMerch: any;
  public isLoading: boolean = false;
  private typeOptionsMap: any;
  private generalTaskMap: any;

  /* @ngInject */
  constructor(private settingsService: SettingsService, private tasksConstants, private $log,
              private $preferences, private bringozLoaderService: BringozLoaderService, private commonsAlertsService: CommonsAlertsService) {
  }

  $onInit() {
    this.typeOptionsMap = this.tasksConstants.generalTasksByAgentType;
    this.generalTaskMap = {};

    this._setGeneralTaskMap(this.generalTasks);
    this.includeRouteStartEndInDispatchMerch = _.find(this.preferences, (p) => {
      return p.key === 'INCLUDE_ROUTE_START_END_IN_DISPATCH_MERCH';
    })
    if (!!this.includeRouteStartEndInDispatchMerch) {
      this.includeRouteStartEndInDispatchMerch.value = JSON.parse(this.includeRouteStartEndInDispatchMerch.value);
    }
  };

  // ******************************
  //        Public methods
  // ******************************

  onTabSelect(type) {
    if (type !== this.type) {
      this.type = type;
      this._getGeneralTasks(type);
    }
  }

  onSaveGeneralTask(taskType) {
    const generalTaskToSave = this.generalTaskMap[taskType];
    this.settingsService.updateGeneralTask(generalTaskToSave)
      .then((updatedGeneralTask) => {
      })
  }

  onIncludeRouteStartEndInDispatchMerchChange(value: boolean) {
    this.includeRouteStartEndInDispatchMerch.value = value;
    const includeRouteStartEndInDispatchMerchCopy = angular.copy(this.includeRouteStartEndInDispatchMerch);
    includeRouteStartEndInDispatchMerchCopy.value = JSON.stringify(value);

    this.isLoading = true;
    this.bringozLoaderService.on();
    this.$preferences().$post([includeRouteStartEndInDispatchMerchCopy])
      .then((res) => {
        this.commonsAlertsService.preferencesByNameSuccess('preferences.INCLUDE_ROUTE_START_END_IN_DISPATCH_MERCH.name');
      })
      .catch((error) => {

      })
      .finally(() => {
        this.isLoading = false;
        this.bringozLoaderService.off();
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  _getGeneralTasks(type) {
    const types = this.typeOptionsMap[type];
    this.settingsService.getGeneralTasks(types)
      .then((generalTasks) => {
        this._setGeneralTaskMap(generalTasks);
      })
      .catch((error) => {
        this.$log.error(error);
      })
  }

  _setGeneralTaskMap(generalTasks) {
    const map = {
      StartDrive: {
        holderType: "StartDrive"
      },
      EndDrive: {
        holderType: "EndDrive"
      },
      StartDayDrive: {
        holderType: "StartDayDrive"
      },
      EndDayDrive: {
        holderType: "EndDayDrive"
      },
      StartMerch: {
        holderType: "StartMerch"
      },
      EndMerch: {
        holderType: "EndMerch"
      },
      StartDayMerch: {
        holderType: "StartDayMerch"
      },
      EndDayMerch: {
        holderType: "EndDayMerch"
      }
    };
    _.forEach(generalTasks, (t) => {
      map[t.holderType] = t;
    })
    this.generalTaskMap = map;
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('generalTasksConfigurationView', {
    bindings: {
      type: '<',
      generalTasks: '<',
      preferences: '<?'
    },
    template: require('./general-tasks-configuration-view.html').default,
    controller: generalTasksConfigurationViewCtrl
  });
